import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddTrialModeAppAnnouncementBarMutationVariables = Types.Exact<{
  markets: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  publishTime: Types.Scalars['DateTime']['input'];
  stopTime: Types.Scalars['DateTime']['input'];
  navigationUrl: Types.Scalars['String']['input'];
  navigationType: Types.Scalars['String']['input'];
  imageUrl: Types.Scalars['String']['input'];
}>;


export type AddTrialModeAppAnnouncementBarMutation = { __typename?: 'Mutation', addTrialModeAppAnnouncementBar: { __typename?: 'Payload', count: number, error?: Types.Error | null } };


export const AddTrialModeAppAnnouncementBarDocument = gql`
    mutation addTrialModeAppAnnouncementBar($markets: [String!]!, $publishTime: DateTime!, $stopTime: DateTime!, $navigationUrl: String!, $navigationType: String!, $imageUrl: String!) {
  addTrialModeAppAnnouncementBar(
    parameter: {markets: $markets, publishTime: $publishTime, stopTime: $stopTime, navigationUrl: $navigationUrl, navigationType: $navigationType, imageUrl: $imageUrl}
  ) {
    count
    error
  }
}
    `;
export type AddTrialModeAppAnnouncementBarMutationFn = Apollo.MutationFunction<AddTrialModeAppAnnouncementBarMutation, AddTrialModeAppAnnouncementBarMutationVariables>;

/**
 * __useAddTrialModeAppAnnouncementBarMutation__
 *
 * To run a mutation, you first call `useAddTrialModeAppAnnouncementBarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrialModeAppAnnouncementBarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrialModeAppAnnouncementBarMutation, { data, loading, error }] = useAddTrialModeAppAnnouncementBarMutation({
 *   variables: {
 *      markets: // value for 'markets'
 *      publishTime: // value for 'publishTime'
 *      stopTime: // value for 'stopTime'
 *      navigationUrl: // value for 'navigationUrl'
 *      navigationType: // value for 'navigationType'
 *      imageUrl: // value for 'imageUrl'
 *   },
 * });
 */
export function useAddTrialModeAppAnnouncementBarMutation(baseOptions?: Apollo.MutationHookOptions<AddTrialModeAppAnnouncementBarMutation, AddTrialModeAppAnnouncementBarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTrialModeAppAnnouncementBarMutation, AddTrialModeAppAnnouncementBarMutationVariables>(AddTrialModeAppAnnouncementBarDocument, options);
      }
export type AddTrialModeAppAnnouncementBarMutationHookResult = ReturnType<typeof useAddTrialModeAppAnnouncementBarMutation>;
export type AddTrialModeAppAnnouncementBarMutationResult = Apollo.MutationResult<AddTrialModeAppAnnouncementBarMutation>;
export type AddTrialModeAppAnnouncementBarMutationOptions = Apollo.BaseMutationOptions<AddTrialModeAppAnnouncementBarMutation, AddTrialModeAppAnnouncementBarMutationVariables>;